import { style, ResponsiveValue } from 'styled-system';

export const applyLineHeightByFontSize = style({
  prop: 'fontSize',
  cssProperty: 'lineHeight',
  key: 'fontSizes',
});

export type ShowElementProps = { show: ResponsiveValue<boolean> };
export const applyShowElementWith = (propName = 'show', display = 'block') =>
  style({
    prop: propName,
    cssProperty: 'display',
    transformValue: (show) => (show ? display : 'none'),
  });

export const applyShowElement = applyShowElementWith();
